import { number, object, ref, string } from 'yup'

import { formatMessage } from 'app/validation/validation.utils'

export const bulkUploadSchema = object().shape({
  listings_file: object()
    .required(formatMessage({ defaultMessage: 'Listings file is required' }))
    .nullable(),
  attachments_file: object()
    .required(formatMessage({ defaultMessage: 'Images file is required' }))
    .nullable()
})

export const VinNumberSchema = object().shape({
  vin: string().length(
    17,
    formatMessage({ defaultMessage: 'VIN code should contain 17 characters' })
  )
})

export const PlaceBidSchema = object().shape({
  price: number()
    .required(formatMessage({ defaultMessage: 'Please enter a bid price' }))
    .nullable()
    .min(1, formatMessage({ defaultMessage: 'Please enter a min bid price 1' }))
    .max(
      999999,
      formatMessage({ defaultMessage: 'Maximum allowed bid price is 999,999' })
    )
    .typeError(formatMessage({ defaultMessage: 'Please enter a bid price' }))
})

export const SetMaxBidSchema = object().shape({
  price: number()
    .required(formatMessage({ defaultMessage: 'Please enter a bid price' }))
    .nullable()
    .min(1, formatMessage({ defaultMessage: 'Please enter a min bid price 1' }))
    .max(
      999999,
      formatMessage({ defaultMessage: 'Maximum allowed bid price is 999,999' })
    )
    .typeError(formatMessage({ defaultMessage: 'Please enter a bid price' }))
})

export const MakeOfferSchema = object().shape({
  price: number()
    .required(formatMessage({ defaultMessage: 'Please enter an offer price' }))
    .nullable()
    .min(
      1,
      formatMessage({ defaultMessage: 'Please enter a min offer price 1' })
    )
    .max(
      999999,
      formatMessage({
        defaultMessage: 'Maximum allowed offer price is 999,999'
      })
    )
    .typeError(
      formatMessage({ defaultMessage: 'Please enter an offer price' })
    ),
  item_quantity: number()
    .required(formatMessage({ defaultMessage: 'Please enter a quantity' }))
    .max(
      ref('available_quantity'),
      formatMessage({
        defaultMessage: 'Please select fewer items'
      })
    )
    .min(
      1,
      formatMessage({
        defaultMessage: 'Please enter a min quantity 1'
      })
    )
    .typeError(formatMessage({ defaultMessage: 'Please enter a quantity' }))
})

export const AddCartListingSchema = object().shape({
  item_quantity: number()
    .test(
      'checkAvailable',
      formatMessage({ defaultMessage: 'Listing is out of stock' }),
      (value, context) => {
        if (context.parent.available_quantity === 0) {
          return false
        }

        return true
      }
    )
    .max(
      ref('available_quantity'),
      formatMessage({
        defaultMessage: 'Please select fewer items'
      })
    )
    .min(
      1,
      formatMessage({
        defaultMessage: 'Please enter a min quantity 1'
      })
    )
    .typeError(formatMessage({ defaultMessage: 'Please enter a quantity' }))
})

export const ChangeAddressSchema = object().shape({
  saved_address: string()
    .required(formatMessage({ defaultMessage: 'Address is required' }))
    .nullable()
})

export const tradePricedSchema = object().shape({
  trade_pricing: number()
    .min(1, formatMessage({ defaultMessage: 'Min 1 percent available' }))
    .max(30, formatMessage({ defaultMessage: 'Max 30 percent available' }))
    .required(formatMessage({ defaultMessage: 'Please enter a trade price' }))
    .typeError(formatMessage({ defaultMessage: 'Please enter a trade price' }))
    .nullable()
})
